import { render, staticRenderFns } from "./MSelectInfo.vue?vue&type=template&id=2717784d&"
import script from "./MSelectInfo.vue?vue&type=script&lang=ts&"
export * from "./MSelectInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports